import React from "react";
import { AppBar, Toolbar, Typography, IconButton, Box } from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();

  return (
    <AppBar position="static" color="primary" sx={{ mb: 2 }} dir="rtl">
      <Toolbar sx={{ justifyContent: "space-between" }}>
      

        {/* כפתור חזרה לדף הבית */}
        <IconButton color="inherit" onClick={() => navigate("/")}>
          <HomeIcon />
        </IconButton>
         <Typography variant="h6" sx={{ fontFamily: "Heebo" }}>
        שמירת כשירות חובשים
          </Typography>
          {/* לוגו + שם */}
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "c" }}>
         
          <img
            src="./logo.png"
            alt="מדיטסט לוגו"
            style={{ height: 46, marginLeft: 1, scale: 1.7}}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
